import { NavLink } from "react-router-dom";



const Footer = () => {

    return (
        <div className="fl-cl footer__container">
            <div className="fl-cl footer__mainDiv">
                <div className="footer__divImg">
                    <NavLink href="/"><img alt="logo Joker Store" className="footer__img" src="https://res.cloudinary.com/dmobuherg/image/upload/v1673296282/samples/jokerstore_letras_cloudinary_centrada_8px_dl5yzd.png" /></NavLink>
                </div>
                <div className="fl-cl footer__containerDiv">
                    <div className="fl-cl footer__links">
                        <div className="footer__link">
                            <NavLink to="/terms">Términos y Condiciones</NavLink>
                        </div>
                        <div className="footer__link" >
                            <NavLink to="/privacity" >Privacidad</NavLink>
                        </div>
                    </div>
                    <div className="fl-rw">
                        <p className="footer__p">Seguinos en</p>
                        <div className="fl-rw">
                            <div className="footer__div__img">
                                <a href="https://www.instagram.com/jokerstore_casilda/" rel="noreferrer" target="_blank"><img alt="logo instagram" className="footer__logos" src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"></img></a>
                            </div>
                            <div>
                                <a href="https://www.facebook.com/JokerVideoclub" rel="noreferrer" target="_blank"><img alt="logo facebook" className="footer__logos" src="https://cdn-icons-png.flaticon.com/512/1419/1419497.png"></img></a>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div>
                    <p style={{ "textAlign": "center", "margin": "0", "paddingTop": "0.5rem" }}>
                        Diseñado y desarrollado por ale.fidececchi@gmail.com
                    </p>
                </div>
            </div>
        </div>)
}

export default Footer;